module.exports = __webpack_public_path__ + "static/media/login.c3b9cf56.png";